export default "__VITE_ASSET__DIcG3UFf__"